import fetch from '../utils/fetch'

export function getWechatPreAuthUrl (query) {
  return fetch({
    url: '/wechat/pre_auth_url',
    method: 'get',
    params: query
  })
}

export function getWechatBind (query) {
  return fetch({
    url: '/wechat/bind',
    method: 'post',
    params: query
  })
}

export function getAuthorizerInfo () {
  return fetch({
    url: 'wechat/authorizerinfo',
    method: 'get',
  })
}

export function getWechatKfs () {
  return fetch({
    url: '/wechat/kfs',
    method: 'get'
  })
}

export function createWechatKfs (query) {
  return fetch({
    url: '/wechat/kfs',
    method: 'post',
    data: query
  })
}

export function updateWechatKfs (query) {
  return fetch({
    url: '/wechat/update/kfs',
    method: 'post',
    data: query
  })
}

export function deleteWechatKfs (query) {
  return fetch({
    url: '/wechat/kfs',
    method: 'delete',
    params: query
  })
}

export function uploadMaterial (query) {
  return fetch({
    url: '/wechat/material',
    method: 'post',
    data: query
  })
}

export function getWechatMaterial (query) {
  return fetch({
    url: '/wechat/material',
    method: 'get',
    params: query
  })
}

export function getMaterialStats (query) {
  return fetch({
    url: '/wechat/material/stats',
    method: 'get'
  })
}

export function deleteWechatMaterial (query) {
  return fetch({
    url: '/wechat/material',
    method: 'delete',
    params: query
  })
}

export function pushNewsImage (file) {
  return fetch({
    url: '/wechat/news/image',
    method: 'post',
    data: file,
  })
}

export function getOpenKfReply () {
  return fetch({
    url: '/wechat/openkf/reply',
    method: 'get',
  })
}

export function setOpenKfReply (query) {
  return fetch({
    url: '/wechat/openkf/reply',
    method: 'post',
    data: query,
  })
}

export function setSubscribeReply (query) {
  return fetch({
    url: '/wechat/subscribe/reply',
    method: 'post',
    params: query,
  })
}

export function getSubscribeReply (query) {
  return fetch({
    url: '/wechat/subscribe/reply',
    method: 'get',
    params: query,
  })
}

export function setDefaultReply (query) {
  return fetch({
    url: '/wechat/default/reply',
    method: 'post',
    data: query,
  })
}

export function getDefaultReply (query) {
  return fetch({
    url: '/wechat/default/reply',
    method: 'get',
    params: query,
  })
}

export function addKeywordReply (query) {
  return fetch({
    url: '/wechat/keyword/reply',
    method: 'post',
    data: query,
  })
}

export function updateKeywordReply(query) {
  return fetch({
    url: '/wechat/keyword/reply',
    method: 'put',
    data: query,
  })
}

export function deleteKeywordReply(query) {
  return fetch({
    url: '/wechat/keyword/reply',
    method: 'delete',
    params: query,
  })
}


export function getKeywordReply () {
  return fetch({
    url: '/wechat/keyword/reply',
    method: 'get',
  })
}

export function createArtical (query) {
  return fetch({
    url: '/wechat/news',
    method: 'post',
    data: query
  })
}

export function updateArtical (query) {
  return fetch({
    url: '/wechat/news',
    method: 'put',
    data: query
  })
}

export function getArtical (media_id) {
  return fetch({
    url: '/wechat/news/' + media_id,
    method: 'get',
  })
}

export function getUserWeekSummary () {
  return fetch({
    url: '/wechat/stats/userweeksummary',
    method: 'get',
  })
}

export function openUserPlatform() {
  return fetch({
    url: '/wechat/open',
    method: 'post',
  })
}

/*
*APP版本路由(刘文浩)
*/
export function saveVsersion(query) {
  return fetch({
    url: '/wechat/version/create',
    method: 'post',
    data: query
  })
}
export function getVsersion(query) {
  return fetch({
    url: '/wechat/version/list',
    method: 'get',
    data: query
  })
}
export function updateVsersion(id,query) {
  return fetch({
    url: '/wechat/version/update/'+id,
    method: 'put',
    data: query
  })
}

// 获取LBS服务商授权KEY列表
export function getLbsKeys (query) {
  return fetch({
    url: '/wechat/lbsservicekeys',
    method: 'get',
    params: query
  })
}

// 新增LBS服务商授权KEY
export function addLbsKeys (query) {
  return fetch({
    url: '/wechat/lbsservicekeys',
    method: 'post',
    data: query
  })
}

// 编辑LBS服务商授权KEY
export function editLbsKeys (query, id) {
  return fetch({
    url: '/wechat/lbsservicekeys/' + id,
    method: 'put',
    data: query
  })
}

// 删除LBS服务商授权KEY
export function delLbsKeys (query) {
  return fetch({
    url: '/wechat/lbsservicekeys/{id}',
    method: 'deltete',
    data: query
  })
}

// 获取LBS服务接口额度列表
export function getLbsApiStock (query) {
  return fetch({
    url: '/wechat/lbsserviceapistock',
    method: 'get',
    params: query
  })
}

// 新增LBS服务接口及额度
export function addLbsApiStock (query) {
  return fetch({
    url: '/wechat/lbsserviceapistock',
    method: 'post',
    data: query
  })
}

// 编辑LBS服务接口及额度
export function editLbsApiStock (query) {
  return fetch({
    url: '/wechat/lbsserviceapistock/{id}',
    method: 'put',
    data: query
  })
}

// 删除LBS服务接口及额度
export function delLbsApiStock (query) {
  return fetch({
    url: '/wechat/lbsserviceapistock/{id}',
    method: 'delete',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/wechat.js